import { Application } from '@components/Component/Container/Application/Application.js';
import { ENV } from '@components/Environment.js';
import { setCookie } from '@components/Utility/index.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { switchMap } from 'rxjs/operators';
/**
 * Class `Login` extends the `Application` class.
 * It provides a mini app that can be used for authentication and forgot password requests.
 * This could be used as the login form for multiple different applications.
 */
export class Login extends Application {
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'Login';
        this.hotkeys = {
            ...this.hotkeys // we are extending the hotkeys from the parent class. 
            ,
            'alt+t': () => {
                const current = ENV('theme');
                const themeList = [
                    '',
                    'dark',
                    'light',
                    'dark-alt',
                    'cream',
                    'mist',
                    'sand',
                    'dark-blue',
                    'dark-green',
                    'dark-red',
                    'carbon',
                    'graphite',
                    'charcoal',
                    'slate',
                    'navy',
                    'chocolate',
                    'pastel-blue',
                    'pastel-lavender',
                    'pastel-mint',
                    'vibrant-teal',
                    'galen-light',
                    'galen-dark'
                ];
                // find what index we are on, and pick the next theme, if we are at the end of the list then restart at the beginning of the array
                const currentIndex = themeList.indexOf(current);
                const nextIndex = currentIndex === themeList.length - 1 ? 0 : currentIndex + 1;
                const nextTheme = themeList[nextIndex];
                this.updateTheme(nextTheme);
                return true;
            }
        };
        this.authRequired = false;
        const navbar = this.componentGet('navbar');
        navbar?.hide();
    }
    initializeCache() {
        return super.initializeCache().pipe(switchMap(() => DIContainer.getInstance('CacheManager').deleteCache('clipboard')), switchMap(() => DIContainer.getInstance('CacheManager').deleteCache('session')), switchMap(() => DIContainer.getInstance('CacheManager').deleteCache('timebill')));
    }
    logout() {
        window.location.reload();
    }
    updateTheme(theme) {
        ENV('theme', theme);
        setCookie('login-theme', theme);
        document.body.classList.forEach(c => { if (c.startsWith('theme-'))
            document.body.classList.remove(c); });
        document.body.classList.add(`theme-${theme}`);
    }
}
Login.VERSION = '$Revision: 112192 $';
